// extracted by mini-css-extract-plugin
export var buttons = "_ad-0";
export var buttonsActive = "_ad-h";
export var cancelConfirm = "_ad-1";
export var closeButton = "_ad-2";
export var column = "_ad-3";
export var container = "_ad-4";
export var detailHeader = "_ad-6";
export var detailTitle = "_ad-7";
export var detailsContent = "_ad-5";
export var header = "_ad-8";
export var headerWithClose = "_ad-9";
export var icon = "_ad-a";
export var infoIcon = "_ad-c";
export var informationContainer = "_ad-b";
export var sideDrawer = "_ad-d";
export var sideDrawerOpen = "_ad-e";
export var stickyFooter = "_ad-f";
export var typeOption = "_ad-g";